<template>
  <section class="bg-grey-lighter font-sans">
    <div class="container m-auto flex flex-col md:flex-row max-w-xl">
      <div
        class="flex flex-col w-full lg:w-1/2 justify-center items-start py-8"
      >
        <label for="tagline" class="uppercase tracking-loose">{{
          this.lead
        }}</label>
        <h1 class="my-4 font-normal">
          Web Development &amp; Digital Marketing with Incredible Results
        </h1>
        <p class="leading-normal mb-4">
          Let us set you up for success by creating effective websites that help
          you to build your brand while you attract and convert new business.
        </p>

        <router-link
          to="/contact"
          class="bg-primary hover:bg-black text-black font-semibold hover:text-white py-2 px-4 border border-black hover:border-transparent"
          >Get In Touch</router-link
        >
      </div>
      <div class="w-full lg:w-1/2 lg:py-6">
        <img
          src="https://stitches.hyperyolo.com/images/demo-devices.png"
          alt="image"
          class="w-full"
        />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Hero",
  props: {
    lead: {
      type: String,
      required: true
    }
  }
};
</script>
